export const ADR_CLASSES_ROUTE = 'klasy-towarow-niebezpiecznych';
